import { render, staticRenderFns } from "./batchImport.vue?vue&type=template&id=963ffbc0&scoped=true"
import script from "./batchImport.vue?vue&type=script&lang=js"
export * from "./batchImport.vue?vue&type=script&lang=js"
import style0 from "./batchImport.vue?vue&type=style&index=0&id=963ffbc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963ffbc0",
  null
  
)

export default component.exports